import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import JSONAPISerializer from '@ember-data/serializer/json-api';
import { inject } from '@ember/service';
import { underscore } from '@ember/string';

var _class, _descriptor;
let ApplicationSerializer = (_class = class ApplicationSerializer extends JSONAPISerializer {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
  }
  keyForAttribute(attr) {
    return underscore(attr);
  }
  keyForRelationship(attr) {
    return underscore(attr);
  }

  // =========================================================================
  // PROTEZIONE ORGANIZATION — Filtro centralizzato
  // =========================================================================
  //
  // L'organization dell'utente loggato contiene dati critici nelle hasMany
  // (contact_states, product_states, event_states, roles, ecc.) che vengono
  // usati ovunque nell'app (calendario, collision detection, settings, ecc.).
  //
  // Quando una qualsiasi risposta API include l'organization come sideload
  // in "included", spesso i dati sono parziali (senza le hasMany) e Ember Data
  // sovrascrive il record completo nello store, corrompendo quei dati.
  //
  // Questo filtro agisce su DUE percorsi:
  //
  // 1. normalizeResponse() — copre findRecord, query, queryRecord, save, reload
  //    (tutte le operazioni standard di Ember Data)
  //
  // 2. pushPayload() — copre tutte le chiamate esplicite store.pushPayload()
  //    sparse nel codice (saveRecordRelated, prenotazioni, e-commerce, ecc.)
  //
  // Il filtro rimuove l'organization del me SOLO quando arriva come sideload
  // in "included". NON filtra quando è il record principale della risposta
  // (es. GET /organizations/:id o salvataggio diretto dell'organization).
  // =========================================================================

  /**
   * Filtra l'organization del me dall'array "included" del payload.
   * Metodo condiviso usato sia da normalizeResponse che da pushPayload.
   *
   * @private
   * @param {Object} payload - Payload JSON:API con possibile array "included"
   * @returns {Object} Payload con organization del me rimossa da "included"
   */
  _filterProtectedOrgFromIncluded(payload) {
    if (!payload?.included || !Array.isArray(payload.included)) {
      return payload;
    }
    const meOrgId = this.session.me?.organization?.id?.toString();
    if (!meOrgId) {
      return payload;
    }
    const filtered = payload.included.filter(inc => {
      const incType = inc.type?.toLowerCase();
      return !((incType === 'organizations' || incType === 'organization') && inc.id?.toString() === meOrgId);
    });
    if (filtered.length === payload.included.length) {
      return payload; // Nessun filtro applicato, ritorna l'originale
    }
    return {
      ...payload,
      included: filtered
    };
  }

  /**
   * Copre: findRecord, query, queryRecord, save, reload
   * (tutte le operazioni standard di Ember Data)
   */
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    // The API sometimes answers 2xx with an empty body (adapter returns null):
    // synthesize an empty JSON:API document instead of crashing deep in the
    // serializer (Sentry EMBER-MEDICAL-2GT/2N5).
    if (!payload) {
      const arrayTypes = ['findAll', 'query', 'findMany', 'findHasMany'];
      payload = arrayTypes.includes(requestType) ? {
        data: []
      } : {
        data: null
      };
    }
    return super.normalizeResponse(store, primaryModelClass, this._filterProtectedOrgFromIncluded(payload), id, requestType);
  }

  /**
   * Copre: tutte le chiamate esplicite store.pushPayload()
   * (saveRecordRelated, prenotazioni, e-commerce, booking, ecc.)
   */
  pushPayload(store, payload) {
    // Callers occasionally forward raw API responses that are empty or have
    // sparse arrays (undefined entries crash the identifier cache — Sentry
    // EMBER-MEDICAL-2RG/2RF): drop what can't be pushed.
    if (!payload || payload.data === undefined && !payload.included) {
      return;
    }
    if (Array.isArray(payload.data)) {
      payload = {
        ...payload,
        data: payload.data.filter(Boolean)
      };
    }
    if (Array.isArray(payload.included)) {
      payload = {
        ...payload,
        included: payload.included.filter(Boolean)
      };
    }
    super.pushPayload(store, this._filterProtectedOrgFromIncluded(payload));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ApplicationSerializer as default };
//# sourceMappingURL=application.js.map
